import React, { useEffect, useState, useMemo } from 'react';
import { useParams, useSearchParams} from 'react-router-dom';
import { useDetalleSolicitudModel } from '../../../modelos/Solicitudes/modeloSolicitud'; 
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad'; 
import DescripcionActividadSolicitud from '../solicitudes/components/infoSolicitudes';
import { formatearFechaCompleta , formatearFechaCorta, formatearPrecio} from '../../../utils/utils'; 
import FileUploader from '../../../components/FileUploader';
import FileViewer from '../../../components/FileViewer';
import { useUsers } from '../../../metodos/userContext';
import { 
  Copy, 
  Video,
  KeyRound,
  Check,
  UserCheck, 
  FileCheck, 
  Bell, 
  DollarSign, 
  RotateCcw, 
  Eye, 
  AlertTriangle,
  FileText,
  MessageSquare,
  AlertCircle,
  Clock,
  User,
  Settings,
  CheckCircle,
  XCircle,
  Send,
  Info,
} from 'lucide-react';
import EditableField from '../../../components/EditableFields';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import useClientesModel from '../../../modelos/Clientes/modeloClientes';
import { useTutoresModel } from '../../../modelos/Tutores/modeloTutores';
import { useisUserAdmin, useNombreEmpresaReal } from '../../../config/unificacion';
import ModuloPagos from './ModuloPagos';
import ModuloPreguntas from './ModuloPreguntas';
import ModuloEntregas from './ModuloEntregas';
import HeaderServicios from './vistas/HeaderServicios';
import ModuloTesis from './ModuloTesis';
import ModuloHistorial from '../../../components/Historial/Historial';
import { useDialog } from '../../../components/Dialogs/Dialogprovider';
import PreguntasComponent from '../solicitudes/Modulos/Preguntas';
import WompiPagoWidget from './Modulos/WompiPago';

const DetallesServicio = () => {
    const { nombreEmpresa, codigo} = useParams();
    let nombreEmpresaReal =  useNombreEmpresaReal(nombreEmpresa);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const [servicioListo, setServicioListo] = useState(false);
    const [solicitudCargada, setSolicitudCargada] = useState(false);
    const [formData, setFormData] = useState({
      trabajos: [],
      comentarioEntrega : "",
    });

    const dialogs = useDialog();

    const [confirmado, setConfirmado] = useState(false);

    const {usuario} = useUsers();
    const {materiasOptions, cargarMaterias} = useListasModel();
    const isAdmin = useisUserAdmin(usuario);

    //copiado
    const [copied, setCopied] = useState(false);
    const handleCopy = (text) => {
      navigator.clipboard.writeText(text).then(() => {
          setCopied(true);
          // Resetea el ícono de 'copiado' después de 2 segundos
          setTimeout(() => setCopied(false), 2000);
      }).catch(err => {
          console.error('Error al copiar texto: ', err);
      });
    };

    //listas
    const {tutoresOptions, cargarTutores} = useTutoresModel();

    //cargar tutores
    useEffect(() =>{
      cargarTutores();
    },[]);
    
    //cargar materias
    useEffect(() =>{
      cargarMaterias();
    },[]);

    const {
        solicitud,
        loadingSolicitudes,
        errorSolicitudes,
        cargarSolicitudPorId,
    } = useDetalleSolicitudModel();

    const {
        servicio,
        loadingServicios,
        errorServicios,
        cargarServicioPorCodigo,
        entregarTrabajoTutor,
        setupWebSocketsServicios,
        updateServicio,
    } = useContabilidadModel();

    const {
          cliente,
          loadingClientes,
          getCliente,
          busquedaClientesOptions,
          handleInputChange,
    } = useClientesModel();

    //tabs que son visibles
    //tener en cuenta materia == TESIS, faltan demas cosas
    const visibleTabs = useMemo(() => {
      let baseTabs;

      if(isAdmin){
        baseTabs = [
            {id: 'general', label: 'General', icon: FileText },
            {id: 'tesis', label: 'Tesis', icon: DollarSign }, 
            {id: 'pagos', label: 'Registrar pagos', icon: DollarSign,},    
            {id: 'entregas', label: 'Entregas / Avances', icon: DollarSign ,},
            {id: 'historial', label: 'Historial', icon: Eye },
            {id: 'preguntas', label: 'preguntas', icon: DollarSign }, 
            {id: 'revision', label: 'Revision', icon: DollarSign }, 
        ];
      }else{
        baseTabs = [
            { id: 'general', label: 'General', icon: FileText },
            { id: 'preguntas', label: 'Preguntas', icon: Settings },
            { id: 'tesis', label: 'Tesis', icon: Settings },
            { id: 'entregas', label: 'Entregas / Avances', icon: CheckCircle },
        ];
      }
        
        // 2. Si el servicio no ha cargado, no muestra nada
        if (!servicio) {
            return [];
        }

        // 3. Aplica los filtros que necesitas
        return baseTabs.filter(tab => {
            // Muestra la pestaña 'Tesis' solo si el servicio es de tipo 'TESIS'
            if (tab.id === 'tesis') {
                return servicio.materia === 'TESIS';
            }
            // Muestra la pestaña 'Entregas' solo si ya hay entregas registradas
            if (tab.id === 'entregas' && !isAdmin) {
                return servicio.entregasTrabajo?.length > 0;
            }
            // La pestaña 'General' y otras que no tengan condición, siempre se muestran
            return true;
        });

    }, [servicio , isAdmin]); 

    const activeTab = useMemo(() => {
      const tabParam = searchParams.get('view');

      const isValidTab = visibleTabs.some(t => t.id === tabParam);

      return isValidTab ? tabParam : 'general';
    }, [searchParams, visibleTabs]);

    const handleTabChange = (tabId) => {
      setSearchParams({ view: tabId });
    }

    // cargar servicio por codigo
    useEffect(() => {
        // Si el servicio ya se cargó o está cargando, no hacer nada
        if (servicioListo ) {
        return;
        }

        let socketCleanup = null;
        
        const cargarServicio = async () => {
            try {
                console.log("Cargando servicio con código:", codigo ,nombreEmpresa);
                const servicioObjeto = await cargarServicioPorCodigo(nombreEmpresa,codigo);

                if(servicioObjeto){
                  socketCleanup = setupWebSocketsServicios(servicioObjeto, nombreEmpresaReal);
                }

                setServicioListo(true);
            } catch (error) {
                console.error("Error al cargar el servicio:", error);
                setServicioListo(false);
            }
        };

        console.log("el codigo es",codigo);
        
        if (codigo) {
            cargarServicio();
        }

        // Cleanup function
        return () => {
            if (socketCleanup) {
                socketCleanup();
            }
        };

    }, [codigo, cargarServicioPorCodigo, loadingServicios]);

    
    // cargar solicitud cuando servicio este listo
    useEffect(() => {
        // Si ya se cargó la solicitud o el servicio no está listo, salir
        if (solicitudCargada || !servicioListo || !servicio) {
        return;
        }
        
        const cargarSolicitud = async () => {
        if (servicio.idsolicitud) {
            try {
            console.log("Cargando solicitud con ID:", servicio.idsolicitud);
            await cargarSolicitudPorId(servicio.idsolicitud,nombreEmpresaReal);
            setSolicitudCargada(true);
            } catch (error) {
            console.error("Error al cargar la solicitud:", error);
            }
        }
        };
        
        cargarSolicitud();
    }, [servicioListo, servicio, cargarSolicitudPorId, solicitudCargada]);

    //cargar cliente xd
    useEffect(() => {
        // Función asíncrona para cargar los datos del cliente
        const cargarCliente = async () => {
            // Asegúrate de que la solicitud exista y tenga una propiedad 'cliente'
            if (solicitud && solicitud.cliente) {
                try {
                    await getCliente(nombreEmpresaReal, solicitud.cliente);
                } catch (error) {
                    console.error("Error al cargar el cliente:", error);
                }
            }
            
        };

        cargarCliente();

    }, [solicitud, nombreEmpresaReal]); // 3. EL EFECTO SE EJECUTA CUANDO 'solicitud' CAMBIA
  
    // Función para manejar el cambio del checkbox
    const handleCheckboxChange = (e) => {
      setConfirmado(e.target.checked);
    };

    //cargas

    if (errorServicios) {
      return (
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
          <strong className="font-bold">Error: </strong>
          <span className="block sm:inline">No se pudo cargar el servicio. Por favor, intente nuevamente.</span>
      </div>
    );
    }

    // Manejo de estados de carga y error
    if (loadingServicios || (servicioListo && loadingSolicitudes && loadingClientes)) {
        return (
        <div className="flex justify-center items-center h-screen">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500">              
            </div>
        </div>
        );
    }
    

    
    if (servicioListo && errorSolicitudes) {
        return (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">Error: </strong>
            <span className="block sm:inline">No se pudo cargar la solicitud. Por favor, intente nuevamente.</span>
        </div>
        );
    }
    
    // Si no hay servicio o no se ha cargado aún
    if (!servicio) {
        return (
        <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">Aviso: </strong>
            <span className="block sm:inline">No se encontró el servicio con el código especificado.</span>
        </div>
        );
    }

    
    const entregarTrabajo = async(e) => {
      console.log("trabajo a entregar ",formData,nombreEmpresa);
      await entregarTrabajoTutor(formData,nombreEmpresa);
      
      setFormData({
        ...formData,
        trabajos: [], // Limpiar el array de archivos
        comentarioEntrega: "" // Opcional: también limpiar comentarios
      });
      //actualizar servicio nuevamente al subir
      await cargarServicioPorCodigo(nombreEmpresa,codigo);
    }

    // Función para manejar cambios en los inputs
    const handleFormularioEntrega = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value
      });
    };

    //tutor view
    const TutorView = () =>{
      return (
        <div>
        {/* Info de entrega - Cards con iconos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6 bg-blue-50">
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-1">
              <div className="bg-blue-100 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <span className="text-gray-500">Fecha límite</span>
            </div>
            <p className="font-medium text-gray-800 ml-10">{formatearFechaCompleta(servicio.fechaentrega)}</p>
          </div>
          
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-1">
              <div className="bg-green-100 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span className="text-gray-500">Precio cobrado</span>
            </div>
            <p className="font-medium text-gray-800 ml-10">{formatearPrecio(servicio?.preciotutor)}</p>
          </div>
          
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-1">
              <div className="bg-purple-100 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
              </div>
              <span className="text-gray-500">Código servicio</span>
            </div>
            <p className="font-medium text-gray-800 ml-10">{servicio?.codigo}</p>
          </div>

          {servicio?.identificadorcodigo == "A" && (
            <div className="bg-white p-4 rounded-lg shadow-sm border-border-gray-100">
              <div className="flex items-center gap-3 mb-1">
                <div className="bg-orange-100 p-2 rounded-full">
                  {/* Icono de Lucide React */}
                  <Video className="h-5 w-5 text-orange-600" strokeWidth={2} />
                </div>
                <span className="text-gray-500">Enlace de la reunión</span>
              </div>
              <a
                href={servicio?.ObjetoAsesoria?.hangoutLink}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-blue-600 hover:underline ml-10"
              >
                Unirse a la reunión
              </a>
            </div>
          )}

        </div>

        {/* Credenciales de plataforma */}
        {solicitud.proPlataforma?.manejoPlataforma && (
            <div className="mt-6">
                {/* === TARJETA ÚNICA Y COMPACTA === */}
                <div className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden font-sans">
                    
                    {/* ENCABEZADO ROJO (Más pequeño) */}
                    <div className="bg-red-600 p-2 flex items-center justify-center text-white space-x-2">
                        <AlertCircle size={18} />
                        <h3 className="font-bold text-base uppercase tracking-normal">
                            Manejo de Plataforma Especial
                        </h3>
                    </div>

                    {/* CUERPO PRINCIPAL */}
                    <div className="p-4">
                        {/* Información resumida */}
                        <p className="text-sm text-gray-700 mb-3">
                            Este servicio requiere gestión completa en plataforma (UNAD). Se debe participar en: <strong>Foros, trabajos colaborativos, videos, etc.</strong>
                        </p>
                        <ul className="text-xs font-semibold text-red-700 space-y-1">
                            <li className="flex items-center"><span className="mr-2">⚠️</span><span>Es fundamental evitar el plagio y el uso excesivo de IA.</span></li>
                        </ul>

                        {/* === SECCIÓN DE CREDENCIALES (CONDICIONAL Y COMPACTA) === */}
                        {cliente?.clienteEspecialPlataformaUNAD && (
                            <div className="mt-4 pt-4 border-t border-gray-200">
                                <div className="flex items-center text-emerald-600 mb-2">
                                    <KeyRound size={16} className="mr-1.5" />
                                    <h4 className="font-bold text-sm">CREDENCIALES DE ACCESO</h4>
                                </div>
                                
                                {/* Grid para mostrar credenciales en columnas */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
                                    {/* Plataforma */}
                                    <div className="bg-gray-50 p-2 rounded-md border">
                                        <p className="text-xs font-semibold text-gray-500">Plataforma</p>
                                        <p className="font-medium text-gray-800 truncate" title={cliente?.infoPlataforma.plataforma}>
                                            {cliente?.infoPlataforma.plataforma}
                                        </p>
                                    </div>
                                    
                                    {/* Usuario */}
                                    <div className="bg-gray-50 p-2 rounded-md border">
                                        <p className="text-xs font-semibold text-gray-500">Usuario</p>
                                        <p className="font-medium text-gray-800 truncate" title={cliente?.infoPlataforma.usuario}>
                                            {cliente?.infoPlataforma.usuario}
                                        </p>
                                    </div>

                                    {/* Contraseña */}
                                    <div className="bg-gray-50 p-2 rounded-md border">
                                        <p className="text-xs font-semibold text-gray-500">Contraseña</p>
                                        <div className="flex items-center justify-between">
                                            <span className="font-mono text-gray-800 select-all">{cliente?.infoPlataforma.contrasena}</span>
                                            <button 
                                                onClick={() => handleCopy(cliente.infoPlataforma.contrasena)}
                                                className="p-1 rounded-md hover:bg-gray-200 transition-colors"
                                                title="Copiar contraseña"
                                            >
                                                {copied ? <Check className="text-green-500" size={16} /> : <Copy className="text-gray-500" size={16} />}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
         )}

        <div className="p-6">

          {/* Descripción actividad - Pestañas mejoradas */}
          <div className="mb-8">
            <DescripcionActividadSolicitud 
                  solicitud={solicitud}
                  initialTab="descripcion"
                />
          </div>

          
         {/* Subir archivos - Diseño mejorado */}
          {!servicio.getTrabajoEntregado() && (
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                </svg>
                Subir archivos
              </h3>
              
              <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-8 text-center mb-4 hover:bg-gray-100 transition-colors">
                <FileUploader
                  formData={formData}
                  setFormData={setFormData}
                  fieldName="trabajos"
                  allowedTypes={[]}
                  maxSize={100 * 1024 * 1024}
                  label="trabajo"
                  multiple={true}
                />
                
                <div className="mt-3 text-sm text-gray-500">

                </div>
              </div>
            </div>
          )}

           {/* Vista de archivos */} 
          <FileViewer 
            IdCarpeta={servicio.codigo}
            nombreEmpresa={nombreEmpresaReal}
            onDeleteFile={(files) => {
            }}/>

          {!servicio.getTrabajoEntregado()  && (servicio.identificadorcodigo !== "P" && servicio.identificadorcodigo != "Q" )? (
            <>
            {/* Comentarios - Diseño mejorado */}
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                </svg>
                Comentarios de entrega
              </h3>
              
              <textarea 
                className="w-full p-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-shadow" 
                rows="4" 
                name="comentarioEntrega"
                value={formData.comentarioEntrega}
                onChange={handleFormularioEntrega}
                placeholder="Añade cualquier comentario o nota adicional para el cliente..."
              ></textarea>

            </div>
            
            {/* Confirmación - Diseño mejorado */}
            <div className="bg-amber-50 p-5 rounded-xl border border-amber-200 mb-8 shadow-sm">
              <div className="flex items-start mb-4">
                <input 
                  type="checkbox" 
                  checked={confirmado}
                  onChange={handleCheckboxChange}
                  id="confirm" 
                  className="mt-1 mr-3 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500" 
                />
                <label htmlFor="confirm" className="text-gray-700 font-medium">
                  Confirmo que este trabajo es 100% original y cumple con <span className="uppercase font-bold text-blue-800">TODOS</span> los requisitos y criterios SOLICITADOS en la descripción de la actividad.
                </label>
              </div>
              
              <div className="bg-white border-l-4 border-red-500 p-4 rounded-r-md mb-4">
                <p className="font-semibold text-red-700 mb-2 flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                  IMPORTANTE:
                </p>
                <ul className="text-sm text-gray-700 ml-5 list-disc space-y-2">
                  <li><span className="font-semibold">Revise detenidamente</span> la información y descripción de la solicitud antes de entregar.</li>
                  <li>Es <span className="font-semibold">OBLIGATORIO</span> adjuntar el reporte de plagio e IA junto con la entrega final (solo si lo requiere, los trabajos que requieren esto son cualquier trabajo que no se haga a mano).</li>
                  <li>No se permiten trabajos con más del <span className="font-semibold">15% de similitud</span> en el reporte de plagio.</li>
                  <li>No se permiten trabajos con más del <span className="font-semibold">20% de contenido generado por IA</span>.</li>
                </ul>
              </div>
              
              <p className="text-sm text-gray-600 italic">
                El incumplimiento de estos criterios resultará en el rechazo del trabajo y posibles penalizaciones.
                Todos los trabajos serán verificados mediante Turnitin.
              </p>
            </div>
            
            {/* Botones - Diseño mejorado */}
            <div className="flex flex-col sm:flex-row justify-end gap-4">
            <button 
              onClick={entregarTrabajo}
              disabled={!confirmado}
              className={`px-6 py-3 rounded-lg transition-colors flex items-center justify-center gap-2 font-medium shadow-md ${
                  confirmado 
                    ? 'bg-green-600 text-white hover:bg-green-700 cursor-pointer' 
                    : 'bg-gray-400 text-gray-600 cursor-not-allowed'
                }`}
              >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Finalizar y entregar
            </button>
            </div>
            </>
          ) : (
            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 mb-8 shadow-sm">
              <div className="flex items-center justify-center mb-4">
                <div className="h-16 w-16 bg-green-100 rounded-full flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-green-700 mb-2">
                ¡Trabajo entregado con éxito!
              </h3>
              <p className="text-center text-green-600 mb-4">
                Este trabajo fue entregado el {formatearFechaCompleta(servicio.entregatutorFecha)}
              </p>
            </div>
          )}

        </div>
        
      </div>
      );
    }

    //acutalizar servicio
    const handleSave = async(field, value) =>{
      console.log("actualizar servivcio",field,value);

      if(field == "fechaentrega"){
        const fechaNueva = new Date(value);
        const fechaActual = new Date();

        if (fechaNueva < fechaActual) {

          const onConfirmarCambio = () => {
            console.log("Usuario confirmó fecha pasada:", field, value);
            updateServicio(servicio.codigo, nombreEmpresaReal, field, value, 'field');
            dialogs.showSuccess('Fecha de entrega actualizada correctamente.');
          };

          dialogs.showConfirm(
            `Estás asignando una fecha de entrega en el PASADO (${formatearFechaCompleta(value)}). ¿Estás seguro de que deseas continuar?`,
            onConfirmarCambio, // Callback simple
            'Advertencia de fecha' // Título
          );
          
          return;

        }
      }

      updateServicio(servicio.codigo, nombreEmpresaReal, field, value, 'field');

    }

    //actualizar tesis
    const handleSaveTesis = async(avances) =>{
      const updateTesis = {
        "calendarioAvances" : avances,
        "calendarioEnviadoACliente" : false,
      };
      //console.log("save tesis",updateTesis);
      updateServicio(servicio.codigo,nombreEmpresaReal,'objetoTesis',updateTesis,'field');
    }

    const auxiliarBusqueda = (field, selectedOption, inputValue) => {
      console.log("auxiliar busqueda",field,selectedOption,inputValue);
      handleInputChange(selectedOption);
    }

    //PREGUNTAS
    const handleEnviarPregunta = async (preguntasActualizadas) =>{

      console.log("a responder pregunta");

      await updateServicio(servicio.codigo, nombreEmpresaReal, 'preguntas', preguntasActualizadas, 'field');

    }


    //admin tabs
    const AdminGeneralTab = () => {
      return (
        <div className="space-y-8">
          {/* INFORMACIÓN GENERAL */}
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Información General
              </h3>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <EditableField
                  field="codigo"
                  label="Código"
                  value={servicio.codigo}
                  type="text"
                  isAdmin={false}
                />
                <EditableField
                  field="materia"
                  label="Materia"
                  value={servicio.materia}
                  options={materiasOptions}
                  type="react-select"
                  isAdmin={isAdmin}
                  onSave={handleSave}
                />
                <EditableField
                  field="fechasistema"
                  label="Fecha sistema"
                  value={servicio.fechasistema}
                  type="date"
                />
                <EditableField
                  field="cliente"
                  label="Número cliente"
                  value={servicio.cliente}
                  onInputChange={auxiliarBusqueda}
                  options={busquedaClientesOptions}
                  type="react-select"
                  isAdmin={isAdmin}
                  onSave={handleSave}
                />
                <EditableField
                  field="tutor"
                  label="Tutor (sistema de notificacion de cambios)"
                  //onInputChange={}
                  options={tutoresOptions}
                  onSave={handleSave}
                  value={servicio.tutor}
                  type="react-select"
                  isAdmin={isAdmin}
                />
                <EditableField
                  field="fechaentrega"
                  label="Fecha de entrega"
                  value={servicio.fechaentrega}
                  type="datetime"
                  isAdmin={isAdmin}
                  onSave={handleSave}
                />
                <EditableField
                  field="idsolicitud"
                  label="ID Solicitud"
                  value={servicio.idsolicitud}
                  type="number"
                />
                <EditableField
                  field="idcontable"
                  label="ID Contable"
                  value={servicio.idcontable}
                  type="number"
                />
                <EditableField
                  field="identificadorcodigo"
                  label="Identificador de código"
                  value={servicio.identificadorcodigo}
                  type="react-select"
                />

                <EditableField
                  field="notasContabilidad"
                  label="Notas de contabilidad"
                  value={servicio.notasContabilidad}
                  type="textarea"
                  onSave={handleSave}
                  isAdmin={isAdmin}
                />

              </div>
            </div>

          </div>

          {/* ZONA PARA ASESORIAS */}
          {servicio.identificadorcodigo == "A" && (
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Zona de Asesorias
              </h3>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                <EditableField
                  field="ObjetoAsesoria.htmlLink"
                  label="card link"
                  value={servicio?.ObjetoAsesoria?.htmlLink}
                  type="text"
                  isAdmin={false}
                />

                <EditableField
                  field="ObjetoAsesoria.hangoutLink"
                  label="Link de google meet"
                  value={servicio?.ObjetoAsesoria?.hangoutLink}
                  type="text"
                  isAdmin={false}
                />

                <EditableField
                  field="ObjetoAsesoria.enlaceGrabacion"
                  label="Enlace de grabacion"
                  value={servicio?.ObjetoAsesoria?.enlaceGrabacion}
                  type="text"
                  isAdmin={true}
                  onSave={handleSave}
                />

              </div>
            </div>

            </div>
          )}
          
          {/* ZONA DE PAGOS */}
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
                Zona de Pagos
              </h3>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                
                {/* PAGOS DE CLIENTE */}
                <div className="bg-blue-50 rounded-lg p-5 border border-blue-200">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="font-medium text-blue-900 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      Pagos Cliente
                    </h4>
                    <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                      {servicio.preciocobrado > 0 ? 'Activo' : 'Sin costo'}
                    </span>
                  </div>
                  
                  <div className="space-y-3">
                    <EditableField
                      field="preciocobrado"
                      label="Precio cobrado"
                      value={servicio.preciocobrado}
                      type="number"
                      isAdmin={isAdmin}
                      onSave={handleSave}
                    />
                    
                    <div className="bg-white rounded-md p-3">
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-600">Total pagado:</span>
                        <span className="font-medium text-green-600">
                          ${servicio.getSumaPagosClientes ? servicio.getSumaPagosClientes() : 0}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-sm mt-1">
                        <span className="text-gray-600">Pendiente:</span>
                        <span className={`font-medium ${
                          servicio.getSaldoPendienteCliente ? 
                            (servicio.getSaldoPendienteCliente() > 0 ? 'text-red-600' : 'text-green-600') 
                            : 'text-gray-500'
                        }`}>
                          ${servicio.getSaldoPendienteCliente()}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-sm mt-1">
                        <span className="text-gray-600">Balance neto:</span>
                        <span className="font-medium text-blue-600">
                          ${servicio.getSumaBalanceClientes ? servicio.getSumaBalanceClientes() : 0}
                        </span>
                      </div>
                    </div>

                  <div className="mt-2">
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                        style={{
                          width: `${servicio.getPorcentajePagoCliente ? servicio.getPorcentajePagoCliente() : 0}%`
                        }}
                      ></div>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      {servicio.getPorcentajePagoCliente ? servicio.getPorcentajePagoCliente() : 0}% pagado
                    </p>
                  </div>
                  </div>
                </div>

                {/* PAGOS DE TUTOR */}
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-200">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="font-medium text-amber-900 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                      Pagos Tutor
                    </h4>
                  </div>
                  
                  <div className="space-y-3">
                    <EditableField
                      field="preciotutor"
                      label="Precio tutor"
                      value={servicio.preciotutor}
                      type="number"
                      isAdmin={isAdmin}
                       onSave={handleSave}
                    />
                    
                    <div className="bg-white rounded-md p-3">
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-600">Estado:</span>
                        <span className={`font-medium ${
                          servicio.getSumaBalanceTutor() == servicio.preciotutor ? 'text-green-600' : 'text-red-600'
                        }`}>
                          {servicio.getSumaBalanceTutor() == servicio.preciotutor ? 'Completado' : 'Pendiente'}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-sm mt-1">
                        <span className="text-gray-600">Monto:</span>
                        <span className="font-medium">${servicio.preciotutor || 0}</span>
                      </div>
                    </div>
                    
                  </div>
                </div>

                {/* PAGOS DE REFERIDOS */}
                <div className="bg-purple-50 rounded-lg p-5 border border-purple-200">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="font-medium text-purple-900 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      Pagos Referidos {servicio.referidoPor} {servicio.gananciaReferido}
                    </h4>
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      servicio.pagoReferido > 0 ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-600'
                    }`}>
                      {servicio.pagoReferido > 0 ? 'Aplicable' : 'No aplica'}
                    </span>
                  </div>
                  
                  <div className="space-y-3">
                    {servicio.pagoReferido > 0 ? (
                      <>
                        <div className="bg-white rounded-md p-3">
                          <div className="flex justify-between items-center text-sm">
                            <span className="text-gray-600">Referido por:</span>
                            <span className="font-medium">{servicio.referidoPor || 'No especificado'}</span>
                          </div>
                          <div className="flex justify-between items-center text-sm mt-1">
                            <span className="text-gray-600">Monto:</span>
                            <span className="font-medium text-purple-600">${servicio.pagoReferido}</span>
                          </div>
                          <div className="flex justify-between items-center text-sm mt-1">
                            <span className="text-gray-600">Estado:</span>
                            <span className={`font-medium ${
                              servicio.referidoPagado ? 'text-green-600' : 'text-red-600'
                            }`}>
                              {servicio.referidoPagado ? 'Pagado' : 'Pendiente'}
                            </span>
                          </div>
                        </div>
                        
                        <button className={`w-full py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                          servicio.referidoPagado 
                            ? 'bg-green-100 text-green-800 cursor-not-allowed' 
                            : 'bg-purple-600 text-white hover:bg-purple-700'
                        }`}>
                          {servicio.referidoPagado ? 'Ya pagado' : 'Marcar como pagado'}
                        </button>
                      </>
                    ) : (
                      <div className="bg-white rounded-md p-3 text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto text-gray-400 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L5.636 5.636" />
                        </svg>
                        <p className="text-sm text-gray-500">No hay pagos de referidos para este servicio</p>
                      </div>
                    )}
                  </div>
                
                </div>
              </div>
            </div>

            {/* SECCIÓN DE PAGOS WOMPI */}
            {/* Calcular 1/2 de pago y 1 pago completo */}
            {/* Programacion de onSucces y programacion de registro de pagos */}
            <WompiPagoWidget 
              valor={servicio.getSaldoPendienteCliente()} 
              referencia={`${servicio.codigo}_${Date.now()}`}
              onSuccess={(datosWompi) => {
                // Cuando Wompi aprueba, registramos en nuestra base de datos local
                //handleRegistrarPago(); 
              }}
              titulo={`pagar por wompi ${servicio.getSaldoPendienteCliente()} `}
            />
            
          </div>

          {/* ZONA DE ENTREGAS */}
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                </svg>
                Zona de Entregas
              </h3>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                
              {/* -------------------- SECCIÓN ENTREGA TUTOR -------------------- */}
              <div className="bg-white border border-indigo-100 rounded-xl shadow-sm overflow-hidden flex flex-col h-full">

                {/* Header Tutor */}
                <div className="bg-indigo-50 px-5 py-4 border-b border-indigo-100 flex items-center justify-between">
                  <h4 className="font-semibold text-indigo-900 flex items-center gap-2">
                    <div className="bg-indigo-200 p-1.5 rounded-lg">
                      {/* Icono de Gorro de graduación o libro */}
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                      </svg>
                    </div>
                    Entrega del Tutor
                  </h4>
                  <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${
                    servicio.getTrabajoEntregado() 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {servicio.getTrabajoEntregado() ? 'Completado' : 'Pendiente'}
                  </span>
                </div>

                {/* Condicional para subir trabajos o permitir resubir trabajo */}
                <div className="p-5 flex-1 flex flex-col justify-between gap-4">
                  
                  {/* Información de Estado */}
                  <div className="bg-gray-50 rounded-lg p-3 border border-gray-100">
                    <div className="flex justify-between items-center text-sm mb-1">
                      <span className="text-gray-500">Fecha de entrega:</span>
                      <span className="font-medium text-gray-800">
                        {servicio.getTrabajoEntregado() && servicio.entregatutorFecha 
                          ? formatearFechaCompleta(servicio.entregatutorFecha) // O usa tu formateador
                          : '--/--/----'}
                      </span>
                    </div>
                  </div>

                  {/* ACCIONES DEL TUTOR */}
                  <div className="space-y-3 mt-2">
                    
                    {servicio.getTrabajoEntregado() ? (
                      /* CASO: YA ENTREGADO */
                      <div className="space-y-3">
                        <div className="flex items-center gap-2 text-green-700 bg-green-50 p-3 rounded-lg text-sm">
                          <CheckCircle size={18} />
                          <span>El tutor ya ha subido los archivos.</span>
                        </div>
                        
                        <button 
                          onClick={() => handleSave('entregatutorFecha', new Date(2023, 0, 1))}
                          disabled={servicio.getTrabajoEntregadoCliente()}
                          className={`
                            w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-sm font-medium transition-all shadow-sm border
                            ${servicio.getTrabajoEntregadoCliente() 
                              ? 'bg-red-50 border-red-200 text-red-400 cursor-not-allowed opacity-75' // Estilo cuando está bloqueado (Rojo bajito y cursor de prohibido)
                              : 'bg-white border-red-200 text-red-600 hover:bg-red-50 hover:border-red-300' // Estilo normal interactivo
                            }
                          `}
                        >
                          <RotateCcw size={16} />
                            Permitir re-subir trabajo (Resetear)

                          {servicio.getTrabajoEntregadoCliente() && (
                            <span className="text-[10px] font-bold uppercase mt-1">
                              NO PERMITIDO POR ENTREGA A CLIENTE
                            </span>
                          )}

                        </button>
                      </div>
                    ) : (
                      /* CASO: PENDIENTE */
                      <div className="space-y-3">
                        {/* Botón 1: Subir archivos manualmente (simulado) */}

                        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                          Subir archivos
                        </h3>

                        <FileUploader
                          formData={formData}
                          setFormData={setFormData}
                          fieldName="trabajos"
                          allowedTypes={[]}
                          maxSize={100 * 1024 * 1024}
                          label="trabajo"
                          multiple={true}
                        />

                        <button 
                          onClick={entregarTrabajo}
                          className={`px-6 py-3 rounded-lg transition-colors flex items-center justify-center gap-2 font-medium shadow-md ${'bg-green-600 text-white hover:bg-green-700 cursor-pointer' }`}
                          >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                          </svg>
                          Finalizar y entregar
                        </button>

                        <div className="relative flex py-1 items-center">
                          <div className="flex-grow border-t border-gray-200"></div>
                          <span className="flex-shrink-0 mx-2 text-gray-400 text-xs">O si ya envió por fuera</span>
                          <div className="flex-grow border-t border-gray-200"></div>
                        </div>

                        {/* Botón 2: Forzar entrega manual */}
                        <button 
                          onClick={() => handleSave('entregatutorFecha', new Date())}
                          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 bg-white border border-indigo-200 text-indigo-700 rounded-lg text-sm font-medium hover:bg-indigo-50 transition-colors"
                        >
                          <FileCheck size={16} />

                          Trabajo No Entregado

                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* -------------------- SECCIÓN ENTREGA CLIENTE -------------------- */}
              <div className="bg-white border border-teal-100 rounded-xl shadow-sm overflow-hidden flex flex-col h-full">
                {/* Header Cliente */}
                <div className="bg-teal-50 px-5 py-4 border-b border-teal-100 flex items-center justify-between">
                  <h4 className="font-semibold text-teal-900 flex items-center gap-2">
                    <div className="bg-teal-200 p-1.5 rounded-lg">
                      <UserCheck size={20} className="text-teal-800"/>
                    </div>
                    Entrega al Cliente
                  </h4>
                  <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${
                    servicio.getTrabajoEntregadoCliente() 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {servicio.getTrabajoEntregadoCliente() ? 'Entregado' : 'Pendiente'}
                  </span>
                </div>

                <div className="p-5 flex-1 flex flex-col justify-between gap-4">
                  
                  {/* Estado de notificación */}
                  <div className={`rounded-lg p-3 border flex items-center justify-between ${
                    servicio.avisoClienteEntrega 
                    ? 'bg-blue-50 border-blue-100 text-blue-800' 
                    : 'bg-gray-50 border-gray-100 text-gray-500'
                  }`}>
                    <div className="flex items-center gap-2 text-sm">
                      {servicio.avisoClienteEntrega ? <Bell size={16} className="text-blue-600"/> : <Bell size={16} />}
                      <span className="font-medium">
                        {servicio.avisoClienteEntrega ? 'Cliente notificado' : 'Cliente NO notificado'}
                      </span>
                    </div>
                    {/* Toggle rápido de notificación si lo necesitas */}
                    <button 
                      onClick={() => handleSave('avisoClienteEntrega', !servicio.avisoClienteEntrega)}
                      className="text-xs underline hover:text-blue-600"
                    >
                      Cambiar
                    </button>
                  </div>

                  {/* ACCIONES DEL CLIENTE */}
                  <div className="space-y-3 mt-2">
                    
                    {servicio.getTrabajoEntregadoCliente() ? (
                      /* CASO: YA ENTREGADO A CLIENTE */
                      <div className="space-y-3">
                          <div className="flex items-center gap-2 text-teal-700 bg-teal-50 p-3 rounded-lg text-sm">
                            <CheckCircle size={18} />
                            <span>Trabajo entregado el {formatearFechaCompleta(servicio.entregaClienteFecha)}</span>
                          </div>

                          <button 
                            onClick={() => handleSave('entregaClienteFecha', new Date(2023, 0, 1))}
                            className="w-full flex items-center justify-center gap-2 py-2.5 px-4 bg-white border border-red-200 text-red-600 rounded-lg text-sm font-medium hover:bg-red-50 hover:border-red-300 transition-all shadow-sm"
                          >
                            <XCircle size={16} />
                            Deshacer entrega (Marcar NO entregado)
                          </button>
                      </div>
                    ) : (
                      /* CASO: PENDIENTE DE ENTREGAR A CLIENTE */
                      <div className="space-y-3">
                        <div className="p-3 bg-yellow-50 text-yellow-800 text-xs rounded-lg flex items-start gap-2">
                          <AlertTriangle size={14} className="mt-0.5 flex-shrink-0"/>
                          Asegúrate de que el trabajo del tutor esté correcto antes de enviar al cliente.
                        </div>

                        {/* Botón Principal: Entregar */}
                        <button 
                          onClick={() => handleSave('entregaClienteFecha', new Date())}
                          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 shadow-md transition-colors"
                        >
                          <Send size={18} />
                          Entregar trabajo al Cliente
                        </button>
                      </div>
                    )}

                  </div>
                </div>
              </div>

              </div>

              {/* Link de Entrega */}
              {servicio.linkEntregaTutor && servicio.linkEntregaTutor !== 'No ha sio entregao' && (
                <div className="mt-6">
                  <h5 className="text-sm font-medium text-gray-700 mb-2">Link de Entrega:</h5>

                  <button 
                    onClick={() => window.open(servicio.linkEntregaTutor, '_blank')}
                    className="w-full text-left bg-blue-50 border border-blue-200 rounded-lg p-3 hover:bg-blue-100 transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.102m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                      </svg>
                      <span className="text-blue-700 text-sm truncate">{servicio.linkEntregaTutor}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </div>

                  </button>

                </div>
              )}

            </div>
          </div>

        </div>
      );
    };

    /**
   * Componente para renderizar una página de entrega de trabajo
   * @param {Object} props - Propiedades del componente
   * @param {Object} props.servicio - El servicio agendado a entregar
   * @param {Object} props.solicitud - La solicitud asociada al servicio
   * @param {string} props.nombreEmpresaReal - Nombre de la empresa cliente
   * @returns {JSX.Element} - El elemento JSX de la página de entrega
   */
    return (
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
        <div className="max-w-7xl mx-auto">
          
          <HeaderServicios servicio={servicio}/>
          
          {/* Contenido Principal */}
          <div className="px-6 pb-8">
            {isAdmin ? (
              <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
                {/* Navegación de tabs mejorada */}
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
                  <nav className="flex space-x-1 overflow-x-auto scrollbar-hide p-2">
                    {visibleTabs.map((tab) => (
                      <button
                        key={tab.id}
                        onClick={() => handleTabChange(tab.id)}
                        className={`group relative py-4 px-6 font-medium text-sm flex items-center gap-3 whitespace-nowrap flex-shrink-0 transition-all duration-300 rounded-2xl ${
                          activeTab === tab.id
                            ? 'bg-white text-blue-700 shadow-lg transform -translate-y-0.5'
                            : 'text-gray-600 hover:text-gray-800 hover:bg-white hover:bg-opacity-60'
                        }`}
                      >
                        {/* Indicador activo */}
                        {activeTab === tab.id && (
                          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-blue-500 rounded-full"></div>
                        )}
                        
                        <div className={`p-2 rounded-lg transition-colors ${
                          activeTab === tab.id ? 'bg-blue-100' : 'bg-gray-200 group-hover:bg-gray-300'
                        }`}>
                          <tab.icon size={16} className={activeTab === tab.id ? 'text-blue-600' : 'text-gray-500'} />
                        </div>
                        
                        <div className="flex flex-col items-start">
                          <span className="hidden sm:inline font-semibold">{tab.label}</span>
                          <span className="sm:hidden font-semibold">
                            {tab.id === 'general' ? 'General' : 
                            tab.id === 'cotizaciones' ? 'Cotiz.' : 
                            tab.id === 'notificaciones' ? 'Notif.' : 'Vistas'}
                          </span>
                          
                          {tab.count !== undefined && tab.count > 0 && (
                            <span className={`mt-1 px-2 py-0.5 text-xs rounded-full font-bold transition-colors ${
                              tab.id === 'cotizaciones' 
                                ? 'bg-green-500 text-white'
                                : tab.id === 'vistas'
                                ? 'bg-blue-500 text-white'
                                : tab.id === 'notificaciones'
                                ? 'bg-orange-500 text-white'
                                : 'bg-gray-500 text-white'
                            }`}>
                              {tab.count}
                            </span>
                          )}
                        </div>
                      </button>
                    ))}
                  </nav>
                </div>

                {/* Contenido de las tabs con padding mejorado */}
                <div className="p-8">
                  {activeTab === 'general' && AdminGeneralTab()}
                  {activeTab === 'tesis' && <ModuloTesis servicio={servicio} onGuardarCalendario={handleSaveTesis} solicitud={solicitud} onGuardarServicio={handleSave}/>}
                  {activeTab === 'pagos' && <ModuloPagos servicio={servicio}/>}
                  {activeTab === 'entregas' && <ModuloEntregas servicio={servicio} isAdmin={isAdmin}/>}
                  {activeTab === 'historial' && <ModuloHistorial historial={servicio.historial}  />}
                  {activeTab === 'preguntas' && 
                    <PreguntasComponent 
                      preguntas={servicio.preguntas}
                      usuarioActual={usuario}
                      isAdmin={isAdmin}
                      onEnviarPregunta={handleEnviarPregunta}
                      onResponderPregunta={handleEnviarPregunta}
                    />
                  }
                  {activeTab === 'revision' && <ModuloPreguntas servicio={servicio} />}
                </div>

              </div>
            ) : (
              <div className="bg-white rounded-3xl shadow-xl overflow-hidden p-8">
                {/* Navegación de tabs mejorada */}
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
                  <nav className="flex space-x-1 overflow-x-auto scrollbar-hide p-2">
                    {visibleTabs.map((tab) => (
                      <button
                        key={tab.id}
                        onClick={() => handleTabChange(tab.id)}
                        className={`group relative py-4 px-6 font-medium text-sm flex items-center gap-3 whitespace-nowrap flex-shrink-0 transition-all duration-300 rounded-2xl ${
                          activeTab === tab.id
                            ? 'bg-white text-blue-700 shadow-lg transform -translate-y-0.5'
                            : 'text-gray-600 hover:text-gray-800 hover:bg-white hover:bg-opacity-60'
                        }`}
                      >
                        {/* Indicador activo */}
                        {activeTab === tab.id && (
                          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-blue-500 rounded-full"></div>
                        )}
                        
                        <div className={`p-2 rounded-lg transition-colors ${
                          activeTab === tab.id ? 'bg-blue-100' : 'bg-gray-200 group-hover:bg-gray-300'
                        }`}>
                          <tab.icon size={16} className={activeTab === tab.id ? 'text-blue-600' : 'text-gray-500'} />
                        </div>
                        
                        <div className="flex flex-col items-start">
                          <span className="hidden sm:inline font-semibold">{tab.label}</span>
                          <span className="sm:hidden font-semibold">
                            {tab.id === 'general' ? 'General' : 
                            tab.id === 'cotizaciones' ? 'Cotiz.' : 
                            tab.id === 'notificaciones' ? 'Notif.' : 'Vistas'}
                          </span>
                          
                          {tab.count !== undefined && tab.count > 0 && (
                            <span className={`mt-1 px-2 py-0.5 text-xs rounded-full font-bold transition-colors ${
                              tab.id === 'cotizaciones' 
                                ? 'bg-green-500 text-white'
                                : tab.id === 'vistas'
                                ? 'bg-blue-500 text-white'
                                : tab.id === 'notificaciones'
                                ? 'bg-orange-500 text-white'
                                : 'bg-gray-500 text-white'
                            }`}>
                              {tab.count}
                            </span>
                          )}
                        </div>
                      </button>
                    ))}
                  </nav>
                </div>

                 {/* Contenido de las tabs con padding mejorado */}
                <div className="p-8">
                  {activeTab === 'general' && TutorView()}
                  {activeTab === 'preguntas' && 
                    <PreguntasComponent 
                        preguntas={servicio.preguntas}
                        usuarioActual={usuario}
                        isAdmin={isAdmin}
                        onEnviarPregunta={handleEnviarPregunta}
                        onResponderPregunta={handleEnviarPregunta}
                      />
                  }
                  {activeTab === 'tesis' && <ModuloTesis servicio={servicio} onGuardarCalendario={handleSaveTesis} solicitud={solicitud}/>}
                  {activeTab === 'entregas' && <ModuloEntregas servicio={servicio} isAdmin={false}/>}
                </div>

              </div>
            )}
          </div>
        </div>

        {/* CSS mejorado para scrollbar */}
        <style jsx>{`
          .scrollbar-hide {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
          
          /* Animación sutil para el indicador de estado */
          @keyframes pulse-gentle {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.7;
            }
          }
          
          .animate-pulse {
            animation: pulse-gentle 2s ease-in-out infinite;
          }
        `}</style>
      </div>
    );

}

export default DetallesServicio
